import { CustomerDataSource } from "@redotech/redo-customer-segments-common/marketing/segments/segment-types";
import { Provider } from "@redotech/redo-order-common/provider";

// Marketing data source per provider; null = no marketing events. Exhaustive so
// a new Provider forces a decision here instead of silently contributing none.
const providerToMarketingDataSource: Record<
  Provider,
  CustomerDataSource | null
> = {
  [Provider.SHOPIFY]: CustomerDataSource.SHOPIFY,
  [Provider.COMMENTSOLD]: CustomerDataSource.COMMENTSOLD,
  [Provider.BIGCOMMERCE]: CustomerDataSource.BIGCOMMERCE,
  [Provider.COMMERCE_CLOUD]: null,
  [Provider.NETSUITE]: null,
  [Provider.MANUAL]: null,
  [Provider.TIKTOK]: null,
  [Provider.AMAZON]: null,
  [Provider.WALMART]: null,
  [Provider.EBAY]: null,
  [Provider.APPAREL_MAGIC]: null,
  [Provider.REDO_MARKETPLACE]: null,
  [Provider.SFOM]: null,
  [Provider.AIMS360]: null,
  [Provider.CIN7_OMNI]: null,
  [Provider.CIN7_CORE]: null,
  [Provider.REDO_API]: null,
  [Provider.CUSTOM_RETURN_INTEGRATION]: null,
  [Provider.REDO]: null,
  [Provider.FAIRE]: null,
  [Provider.WOOCOMMERCE]: null,
  [Provider.WAYFAIR]: null,
  [Provider.SPS_COMMERCE]: null,
  [Provider.BRIGHTPEARL]: null,
  [Provider.LINNWORKS_TRACKSTAR]: null,
  [Provider.LINNWORKS_DIRECT]: null,
  [Provider.TEMU]: null,
  [Provider.RITHUM]: null,
  [Provider.APTOS]: null,
  [Provider.FINALE]: null,
};

// REDO is platform-agnostic and always available.
export function providersToDataSources(
  providers: Provider[],
): CustomerDataSource[] {
  return [
    CustomerDataSource.REDO,
    ...providers
      .map((provider) => providerToMarketingDataSource[provider])
      .filter((source) => source != null),
  ];
}
